module.exports = __webpack_public_path__ + "static/media/info_white.d1f07409.svg";